import type { ReactNode } from "react";

/** One labelled fact in a mobile record card. Composes with the shared
 * `.stack-list` / `.stack-card` responsive table fallback. */
export function CardField({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <p className="mt-1.5 grid gap-0.5 text-sm leading-tight">
      <span className="text-[0.68rem] font-bold tracking-[0.08em] text-[var(--muted-foreground)] uppercase">
        {label}
      </span>
      {children}
    </p>
  );
}
